import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { UploadAttachments } from "components";
import SectionsCard from "../shared/tripReconiliation/SectionsCard";
import {
    deleteAllAttachments,
    deleteTripAttachment,
    uploadTripAttachments,
} from "modules/trips/api";
import { convertFileToBase64 } from "utils/getBase64";
import { mapResourceObjectToArray } from "utils/jsonApiUtils";
import { useSelector } from "react-redux";
import { pointsAttachmentsSelector } from "modules/trips/slice";

const Tripdocuments = ({ tripId }) => {
    const attachments = mapResourceObjectToArray(useSelector(pointsAttachmentsSelector())) || [];
    const [tripDocs, setTripDocs] = useState(attachments);

    console.log(tripDocs, "tripDocs");
    console.log(attachments, "attachments");

    const handleFilesChange = async (event) => {
        if (event.length > 0) {
            await Promise.all(
                event.map(async (file) => {
                    const convertedFile = await convertFileToBase64(file);
                    uploadTripAttachments(tripId, convertedFile);
                })
            );
        }
    };

    const handleDeleteUploadedAttachment = (id) => {
        deleteTripAttachment(id).then(() => {
            setTripDocs(tripDocs.filter((doc) => doc.id !== id));
        });
    };

    return (
        <SectionsCard title={<FormattedMessage id="trip.reconciliation.tip.documents" />}>
            <UploadAttachments
                isEditable
                name="tripDocs"
                maxLength={100}
                onDeleteUploadedItem={handleDeleteUploadedAttachment}
                onFilesChange={(e) => handleFilesChange(e)}
                hideDeleteAllButton
                uploadedAttachments={tripDocs}
            />
        </SectionsCard>
    );
};

export default Tripdocuments;
